export function siteMarkerPosition(site: {
  latitude: number; longitude: number; markerLatitude?: number; markerLongitude?: number;
}): [number, number] {
  const { markerLatitude: lat, markerLongitude: lng } = site;
  return typeof lat === 'number' && typeof lng === 'number' &&
    Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180
    ? [lng, lat] : [site.longitude, site.latitude];
}
export type MarkerEditDraft = { siteId: string; coordinates: [number, number] };
